export const ItemTypes = {
    ROW_GROUP: 'rowGroup',
};
